import { FinancialsPanel } from "@/features/bookkeeping/components/financials-panel";
import { useActiveClient } from "@/layouts/client-layout";

export default function FinancialsPage() {
  const { client } = useActiveClient();
  return <FinancialsPanel clientId={client.id} />;
}
